import { Injectable } from '@angular/core';

export const StorageKeys = {
  microsoft: {
    username: 'username',
    correo: 'correo',
    identificador: 'identificador',
  },
} as const;

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  getSession(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  setSession(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  removeSession(key: string): void {
    sessionStorage.removeItem(key);
  }

  clearSession(): void {
    sessionStorage.clear();
  }

  getLocal(key: string): string | null {
    return localStorage.getItem(key);
  }

  setLocal(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeLocal(key: string): void {
    localStorage.removeItem(key);
  }

  clearLocal(): void {
    localStorage.clear();
  }

  getMicrosoftIdentifier(): string | null {
    return this.getSession(StorageKeys.microsoft.identificador) ?? this.getLocal(StorageKeys.microsoft.identificador);
  }

  setMicrosoftSession(user: { username?: string; correo?: string; identificador?: string }): void {
    if (user.username != null) this.setSession(StorageKeys.microsoft.username, user.username);
    if (user.correo != null) this.setSession(StorageKeys.microsoft.correo, user.correo);
    if (user.identificador != null) this.setSession(StorageKeys.microsoft.identificador, user.identificador);
  }
}

